<dx-autocomplete
  class="autocomplete"
  searchMode="StartsWith"
  itemTemplate="item"
  [valueExpr]="valueExpr"
  [dataSource]="dataSource"
  [showClearButton]="showClearButton"
  [placeholder]="placeholder"
  (onItemClick)="autocompleteItemClick($event)"
  [disabled]="disabled"
  [selectedItem]="selectedValue"
  (onValueChanged)="valueChanged.emit($event)"
  (onOpened)="opened($event)"
>
  <div
    *dxTemplate="let item of 'item'"
    class="instrument-select-item"
  >
    <div class="instrument-select-item__name-container">
      <div class="name-and-exchange">{{item.nameAndExchange}}</div>
      <div class="stock-type">
        {{getEntityType(item)}} - {{item.region}}
      </div>
    </div>
    <div class="instrument-select-item__company-container">
      <div
        class="company"
        title="{{item.company}}"
      >
        {{item.company}}
      </div>
    </div>
  </div>
</dx-autocomplete>
